import { formatTimer } from "@kalyzee/kalyzee-ui";
import { MainClockRenderer } from "../renderers/mainClock";
import { RecordIndicator } from "./RecordIndicator";
import styles from "./ElapsedTimerPill.module.css";
import clsx from "clsx";

export interface ElapsedTimerPillProps {
  since: Date;
  className?: string;
}

export const ElapsedTimerPill = ({ since, className }: ElapsedTimerPillProps) => {
  return (
    <div className={clsx(styles.pill, className)}>
      <RecordIndicator className={styles.dot} />
      <MainClockRenderer
        render={() => <span className={styles.time}>{formatTimer(since)}</span>}
      />
    </div>
  );
};
